export default {
  remove(url) {
    return axios.delete(url);
  }
};
